import type { ThemeMode } from "@carbon6/c6-frontend-design";

/**
 * 에피소드 품질 이슈 태그 칩의 색. 켜짐과 꺼짐 두 가지뿐이다.
 *
 * 카탈로그 라벨은 자기 색을 가지지만 이 어휘는 색이 없다. 중립색(0=검정)으로 그리면 모든 칩이
 * 회색으로 보여 줄을 구분하기 어렵다. 그래서 꺼짐에도 색조를 하나 준다. 이 줄에서 가장
 * 중요한 신호는 **선택 여부**다. 그래서 켜짐은 따뜻한 호박색, 꺼짐은 차가운 청회색으로 둔다.
 * 사용자는 색온도만으로도 두 상태를 구분한다. 갈래별로 색을 나누면 꺼진 칩도 색이 제각각이
 * 되어 "몇 개 골랐나" 를 알기 어렵다.
 *
 * 호박색은 결함이 실패(빨강)가 아니라 "보고 넘어갈 것" 이라는 주의라는 뜻이다. 빨강은 제외
 * 토글이 쓰므로 여기서는 쓰지 않는다.
 *
 * 테마별 단계 규칙은 facet 칩(`filter/facetChipColors.ts`)과 같다. **라이트는 어두운 단계(700),
 * 다크는 밝은 단계(300)** 를 써야 c6 LabelChip 의 12% 배경 위에서 키캡과 글자가 배경과
 * 구분된다. 값은 Tailwind 팔레트다(앱의 다른 리터럴 색과 같은 계열).
 */
const ON_COLOR = { light: 0xb45309, dark: 0xfcd34d }; // amber
const OFF_COLOR = { light: 0x475569, dark: 0xcbd5e1 }; // slate

export function episodeQualityTagChipColor(selected: boolean, mode: ThemeMode): number {
  return (selected ? ON_COLOR : OFF_COLOR)[mode];
}
